import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionTransition } from './components/SolutionTransition';
import { AchievementsSection } from './components/AchievementsSection';
import { ContentBreakdown } from './components/ContentBreakdown';
import { BonusesSection } from './components/BonusesSection';
import { IncomePotential } from './components/IncomePotential';
import { PricingWidget } from './components/PricingWidget';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { SocialProofPopup } from './components/SocialProofPopup';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // SEO: Set lang and meta description
    document.documentElement.lang = 'es';
    const existingMeta = document.querySelector('meta[name="description"]');
    if (!existingMeta) {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Aprendé a aplicar pisos epoxi y cobrá tu primer trabajo en menos de 30 días. Sistema paso a paso sin experiencia previa. Mega Pack Pisos Epoxi Pro Desde Cero.';
      document.head.appendChild(meta);
    }
    const existingViewport = document.querySelector('meta[name="viewport"]');
    if (!existingViewport) {
      const viewport = document.createElement('meta');
      viewport.name = 'viewport';
      viewport.content = 'width=device-width, initial-scale=1';
      document.head.appendChild(viewport);
    }
    // Meta Pixel Code - safe injection for SPA environments
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    window.fbq('init', '832917643091578');
    window.fbq('track', 'PageView');
    // Track AddToCart on all cart buttons
    const handleAddToCart = () => {
      if (window.fbq) {
        window.fbq('track', 'AddToCart');
      }
    };
    // Attach listeners to all cart links
    const links = document.querySelectorAll('a[href*="pagos.avanzalab.online"]');
    links.forEach(link => {
      link.addEventListener('click', handleAddToCart);
    });
    return () => {
      links.forEach(link => {
        link.removeEventListener('click', handleAddToCart);
      });
    };
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] font-sans text-white selection:bg-amber-500/30 selection:text-white" data-id="element-0">
      {/* 1. Hero */}
      <HeroSection data-id="element-1" />

      {/* 2. Problema */}
      <ProblemSection data-id="element-2" />

      {/* 3. Transición a Solución */}
      <SolutionTransition data-id="element-3" />

      {/* 4. Beneficios */}
      <AchievementsSection data-id="element-4" />

      {/* 5. Qué incluye el Mega Pack */}
      <ContentBreakdown data-id="element-5" />

      {/* 7. Bonos */}
      <BonusesSection data-id="element-6" />

      {/* 8. Beneficio económico / Valor */}
      <IncomePotential data-id="element-7" />

      {/* 9. Precio + CTA */}
      <PricingWidget data-id="element-8" />

      {/* 10. FAQ */}
      <FAQSection data-id="element-9" />

      {/* 11. Final CTA */}
      <FinalCTA data-id="element-10" />

      {/* 12. Social Proof Popup */}
      <SocialProofPopup data-id="element-11" />

      {/* Footer */}
      <footer className="bg-black text-gray-600 py-8 text-center text-sm border-t border-gray-800" role="contentinfo" data-id="element-12">
        <p data-id="element-13">© 2026 Mega Pack Pisos Epoxi Pro. Todos los derechos reservados.</p>
      </footer>
    </div>;
}